import './PBFMenuTile.style.less'
import * as React from 'react'
// import cx from 'classnames'
// import { isDark } from '@/utils/darkmode'
import { Doughnut } from 'react-chartjs-2'

interface Props {
  title: string | React.ReactNode
  qty: number
  isActive?: boolean
  icon?: React.ReactNode
  color: string
  isProgress?: boolean
  data?: number[]
  isSelected: boolean
  onClick?: () => any
}

function PBFMenuTile({
  title,
  qty,
  icon,
  color,
  isProgress = false,
  data,
  onClick,
  isSelected = false,
}: Props) {
  const [plugins, setPlugins] = React.useState<any>()

  React.useLayoutEffect(() => {
    const plugins = [
      {
        id: 'activeOrders',
        afterDraw: function (chart) {
          const {
            ctx,
            chartArea: { width, height },
          } = chart
          ctx.save()

          const label = chart.config.data.datasets[0].label

          ctx.font = '16px sans-serif'
          ctx.textAlign = 'center'
          ctx.textStyle = '#5B5B5B'
          ctx.fontWeight = 'bold'
          ctx.fillText(label, width / 2, height / 2 + 14 * 0.34)
        },
      },
    ]

    setPlugins(plugins)
  }, [qty])

  const classBackground = !isSelected
    ? 'pbf-tile-menu-container'
    : 'pbf-tile-menu-container selected-tile'

  if (isProgress) {
    return (
      <div
        className={classBackground}
        style={{
          color,
          cursor: 'pointer',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onClick={onClick}
      >
        <div className="pbf-landing-page-tile-icon">
          {qty && (
            <div className="pbf-landing-page-chart">
              <Doughnut
                data={{
                  labels: ['Urgent', 'Warning', 'On-track'],
                  datasets: [
                    {
                      label: `${qty}`,
                      data,
                      backgroundColor: [
                        '#C03261',
                        '#EF9747',
                        '#4A8DC0',
                        '#848484',
                      ],
                      borderWidth: 0,
                    },
                  ],
                }}
                plugins={plugins}
                options={{
                  plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false },
                    datalabels: null,
                  },
                  cutout: '70%',
                  hover: { mode: null },
                }}
              />
            </div>
          )}
        </div>
        <div className="pbf-landing-page-tile-container">
          <div className="pbf-landing-page-tile-title">{title}</div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={classBackground}
      onClick={onClick}
      style={{ color, cursor: onClick && 'pointer' }}
    >
      <div className="pbf-landing-page-tile-icon">{icon}</div>
      <div className="pbf-landing-page-tile-container">
        <div className="pbf-landing-page-tile-title">{title}</div>
        <div className="pbf-landing-page-tile-qty">{qty}</div>
      </div>
    </div>
  )
}

export default PBFMenuTile
